import axios from "axios";

const API = process.env.REACT_APP_API_URL;
const API_GO = process.env.REACT_APP_API_GO;

export const getGlobalProducts = async (params) => {
	const { data } = await axios.get(`${API}/products/all`, {
		params,
	});
	return data;
};

export const getProduct = async (params) => {
	const { data } = await axios.get(`${API}/products/modal`, {
		params,
	});
	return data;
};

export const getAvailableProducts = async (params) => {
	const { data } = await axios.get(`${API}/admin/products/available`, {
		params,
	});
	return data;
};

export const getBulkProductSuggestions = async (terms) => {
	const { data } = await axios.post(`${API_GO}/app/maintainer/products/suggestions`, {
		terms,
	});
	return data;
};

export const getProductPriceHistory = async (params) => {
	const { data } = await axios.get(`${API_GO}/app/maintainer/products/history_price`, {
		params,
	});
	return data;
};

export const getSeasonsData = async (params) => {
	const { data } = await axios.get(`${API_GO}/app/maintainer/products/lookups`, {
		params,
	});
	return data;
};
